// extracted by mini-css-extract-plugin
export var promotionLink = "_vg-0";